import { Component, HostListener, Input, OnInit, ViewChild } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

import {
    ApexAxisChartSeries,
    ApexChart,
    ChartComponent,
    ApexDataLabels,
    ApexPlotOptions,
    ApexYAxis,
    ApexLegend,
    ApexStroke,
    ApexXAxis,
    ApexFill,
    ApexTooltip,
    ApexTitleSubtitle
} from "ng-apexcharts";

type ChartOptions = {
    series: ApexAxisChartSeries;
    chart: ApexChart;
    dataLabels: ApexDataLabels;
    plotOptions: ApexPlotOptions;
    yaxis: ApexYAxis;
    xaxis: ApexXAxis;
    fill: ApexFill;
    tooltip: ApexTooltip;
    stroke: ApexStroke;
    legend: ApexLegend;
    title: ApexTitleSubtitle
};

@Component({
    selector: "lib-grouped-bar-chart",
    templateUrl: "./grouped-bar-chart.component.html"
})
export class GroupedBarChartComponent implements OnInit {

    @Input() horizontal: boolean;
    @Input() categorias: any;
    @Input() data: any;
    @Input() nombre: string;
    @Input() title: string;
    @Input() valorMaximo: number;
    @Input() colors: any;

    public smallScreen: boolean;
    private readonly _BREAKPOINT_SIZE_SCREEN = 1375;

    @ViewChild("chart") chart: ChartComponent;
    public chartOptions: Partial<ChartOptions>;

    constructor(private readonly _translate: TranslateService) {
        this.smallScreen = window.innerWidth <= this._BREAKPOINT_SIZE_SCREEN ? true : false;
      }

      @HostListener('window:resize')
      onWindowResize() {
          console.log('window:resize');
          this.smallScreen = window.innerWidth <= this._BREAKPOINT_SIZE_SCREEN ? true : false;
          this.drawChart();
      }

    ngOnInit() {
        this.drawChart();
    }

    private drawChart() {
        this.chartOptions = {
            series: this.data,
            chart: {
                type: "bar",
                height: this.horizontal ? (( this.categorias.length + 2) * 50) : (this.smallScreen ? 600 : 1024),
                width: this.horizontal ? (this.smallScreen ? 750 : 1024) : (500),
                redrawOnWindowResize: true,
                fontFamily: 'medium',
                animations: {
                    enabled: false
                }
            },
            plotOptions: {
                bar: {
                    horizontal: this.horizontal,
                }
            },
            dataLabels: {
                enabled: false
            },
            stroke: {
                width: 1,
                colors: ["#fff"]
            },
            xaxis: {
                categories: this.categorias,
                min: undefined,
                max: (Number.isInteger(this.valorMaximo)) ? this.valorMaximo : (Math.round(this.valorMaximo / 10) * 10) + 10,
                labels: {
                    style: {
                        fontSize: '11.8px',
                        fontFamily: 'medium',
                        colors: '#184d39'
                    },
                    formatter: (val) =>  {
                        return isNaN(+val) ? val.toString() : (((+val >= 2000 && +val <= 2200) ? parseInt(val.toString()).toString() : Number(val).toLocaleString(this._translate.getDefaultLang(), {minimumFractionDigits: 0, maximumFractionDigits: 0})));
                        }
                }
            },
            yaxis: {
                title: {
                    text: undefined
                },
                min: undefined,
                max: (Number.isInteger(this.valorMaximo)) ? this.valorMaximo : (Math.round(this.valorMaximo / 10) * 10) + 10,
                labels: {
                    minWidth: 75,
                    maxWidth: 150,
                    style: {
                        fontSize: '11.8px',
                        fontFamily: 'medium',
                        colors: '#184d39'
                    },
                    formatter: (val) =>  {
                        return isNaN(+val) ? val.toString() : (((+val >= 2000 && +val <= 2200) ? parseInt(val.toString()).toString() : Number(val).toLocaleString(this._translate.getDefaultLang(), {minimumFractionDigits: 0, maximumFractionDigits: 0})));
                      }
                }
            },
            fill: {
                opacity: 1,
                colors: this.colors
            },
            legend: {
                position: "top",
                horizontalAlign: "center",
                offsetX: (this.smallScreen ? 40 : 70),
                offsetY: 0,
                width: (this.smallScreen ? 400 : 900),
                markers: {
                    fillColors: this.colors
                }
            },
            tooltip: {
                marker: {
                    show: false,
                },
                y: {
                    formatter: (val) => {
                      let dataLabel;
                      isNaN(+val) ? dataLabel = val.toString() +  + ' ' + this.nombre :
                        dataLabel = Number(val).toLocaleString(this._translate.getDefaultLang(), {minimumFractionDigits: 0, maximumFractionDigits: 0}) + ' ' + this.nombre;
                      return dataLabel;
                    }
                }
            },
            title: {
                text: this.title ? this.title : undefined,
                align: 'center',
                offsetX: 0,
                offsetY: 0,
                floating: false,
                style: {
                    fontSize: '14px',
                    fontFamily: 'medium',
                    color: '#184d39'
                },
            },
        };
    }
}
